
import React from "react";
import Apply1 from "../../assets/Career/Apply1.svg";
import Apply2 from "../../assets/Career/Apply2.svg";
import Apply3 from "../../assets/Career/Apply3.svg";
import Boot41_ban_button from "../common/Boot41_ban_button";
import Boot41_ban_text from "../common/Boot41_ban_text";

const Boot41Banner = ({ onlyButton = false, btntext, text ,to }) => (
  <div className="flex w-full px-[20px] mb-[60px] md:mt-[36px]">
    <div
      className={
        onlyButton
          ? ""
          : "flex flex-col md:flex-row items-center justify-between w-full box-border py-4 px-2 rounded-lg border border-[#EBEBEB] bg-white shadow-[0px_40px_11px_0px_rgba(0,0,0,0),0px_26px_10px_0px_rgba(0,0,0,0.01),0px_14px_9px_0px_rgba(0,0,0,0.05),0px_6px_6px_0px_rgba(0,0,0,0.09),0px_2px_4px_0px_rgba(0,0,0,0.10)] gap-[10px] self-stretch"
      }
    >
      {!onlyButton && (
        <div className="flex items-center gap-0 min-w-0 w-full">
          {/* Three avatars */}
          <span className="w-[58px] h-[51px] flex-shrink-0 rounded-[58px] flex items-center justify-center z-10">
            <img
              src={Apply1}
              alt="Apply1"
              className="w-[58px] h-[51px] rounded-[58px] object-cover"
            />
          </span>
          <span
            className="w-[58px] h-[51px] flex-shrink-0 rounded-[58px] flex items-center justify-center z-20"
            style={{ marginLeft: "-25px" }}
          >
            <img
              src={Apply2}
              alt="Apply2"
              className="w-[58px] h-[51px] rounded-[58px] object-cover"
            />
          </span>
          <span
            className="w-[58px] h-[51px] flex-shrink-0 rounded-[58px] flex items-center justify-center z-30"
            style={{ marginLeft: "-25px" }}
          >
            <img
              src={Apply3}
              alt="Apply3"
              className="w-[58px] h-[51px] rounded-[58px] object-cover"
            />
          </span>
          <Boot41_ban_text text={text}></Boot41_ban_text>
        </div>
      )}

      {/* Apply Now button */}
      <div className="w-full flex justify-end">
        <Boot41_ban_button btntext={btntext} to={to}></Boot41_ban_button>
      </div>
    </div>
  </div>
);

export default Boot41Banner;
